module.exports = __webpack_public_path__ + "f631a56f21894a5e4c368b952891dbbf.png";